<template>
	<span>
		<span v-if="user.isActive === 'false'">
			<b-badge variant="secondary">Inactive</b-badge>
		</span>
		<span v-else>
			<b-badge variant="success">Active</b-badge>
		</span>
	</span>
</template>

<script>
export default {
	name: 'user-status',
	props: {
		user: {
			type: Object,
			required: true
		}
	}
};
</script>

<style></style>